/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const MOBILE_LAYOUT = 'MOBILE_LAYOUT';
export const DESKTOP_LAYOUT = 'DESKTOP_LAYOUT';

export const LAYOUT_CHANGED = 'LAYOUT_CHANGED';
export const layoutChanged = (layout) => ({
  type: LAYOUT_CHANGED,
  layout
});

export const SALESFORCE_CHECK = 'SALESFORCE_CHECK';

export const SET_RETURNING_PAM_USER = 'SET_RETURNING_PAM_USER';

export const setReturningPAMUser = (isReturning) => {
  return {
    type: SET_RETURNING_PAM_USER,
    isReturning
  };
};
